import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewPageSelect = ({
  allowCreate,
  disabled,
  onChange,
  options,
  placeholder,
  value
}) => /*#__PURE__*/_jsx(Select, {
  "data-test-id": "preview-page-select",
  clearable: true,
  disabled: disabled,
  allowCreate: allowCreate,
  onChange: onChange,
  options: options,
  value: value,
  placeholder: placeholder || I18n.text('fullPreview.placeholder')
});
export default PreviewPageSelect;